// Typed Redux hooks — usar no lugar de useSelector/useDispatch direto.
//
// useAppSelector aceita seletor tipado contra AppRootState (declarado
// manualmente em types.ts porque os reducers ainda são .js).
//
// useAppDispatch tem dispatch nativo do RTK; tipagem específica de actions
// async (thunks) precisaria de cada action ser typed — por enquanto retorna
// AppDispatch padrão que aceita qualquer action.
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { AppDispatch } from "./index";
import type { AppRootState } from "./types";

export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
